import React from 'react';
import Layout from '../../components/layout/AppLayout';
import Header from '../../../shared/components/layout/Header';
import SalesReceivables from '../SalesReceivables';

const SalesReceivablesPage = () => {
  return (
    <Layout>
      <div className="flex h-[100dvh] min-h-0 flex-col overflow-hidden">
        <div className="z-50 shrink-0">
          <Header data={{ name: 'Sales Receivables' }} backArrow={true} />
        </div>
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
          <SalesReceivables />
        </div>
      </div>
    </Layout>
  );
};

export default SalesReceivablesPage;
